import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MFAOptions = ({ onVerify, onCancel }) => {
  const [selectedMethod, setSelectedMethod] = useState('sms');
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');

  const methods = [
    {
      id: 'sms',
      label: 'SMS Verification',
      icon: 'Smartphone',
      description: 'Receive code via text message'
    },
    {
      id: 'authenticator',
      label: 'Authenticator App',
      icon: 'Shield',
      description: 'Use authentication app'
    }
  ];

  const handleVerify = () => {
    if (verificationCode?.length !== 6) {
      setError('Please enter a valid 6-digit code');
      return;
    }
    
    if (verificationCode === '123456') {
      onVerify();
    } else {
      setError('Invalid verification code. Try 123456');
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 p-4 bg-primary/10 border border-primary rounded-lg">
        <Icon name="ShieldCheck" size={24} color="var(--color-primary)" />
        <div>
          <p className="text-sm font-semibold text-primary">Multi-Factor Authentication Required</p>
          <p className="text-xs text-muted-foreground mt-1">
            HIPAA compliance requires additional verification
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {methods?.map((method) => (
          <button
            key={method?.id}
            type="button"
            onClick={() => {
              setSelectedMethod(method?.id);
              setError('');
            }}
            className={`flex items-start gap-3 p-4 rounded-lg border-2 transition-smooth text-left ${
              selectedMethod === method?.id
                ? 'border-primary bg-primary/10' :'border-border bg-card hover:border-primary/50'
            }`}
          >
            <Icon 
              name={method?.icon} 
              size={20} 
              color={selectedMethod === method?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} 
            />
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-semibold ${
                selectedMethod === method?.id ? 'text-primary' : 'text-foreground'
              }`}>
                {method?.label}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {method?.description}
              </p>
            </div>
          </button>
        ))}
      </div>
      <Input
        label="Verification Code"
        type="text"
        placeholder="Enter 6-digit code"
        value={verificationCode}
        onChange={(e) => {
          setVerificationCode(e?.target?.value?.replace(/\D/g, '')?.slice(0, 6));
          setError('');
        }}
        error={error}
        maxLength={6}
        className="font-mono text-center text-lg md:text-xl tracking-widest"
      />
      <div className="flex gap-3">
        <Button
          variant="outline"
          fullWidth
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          variant="default"
          fullWidth
          onClick={handleVerify}
          iconName="CheckCircle"
          iconPosition="left"
        >
          Verify
        </Button>
      </div>
      <p className="text-xs text-center text-muted-foreground">
        Mock code for testing: <span className="font-mono font-semibold">123456</span>
      </p>
    </div>
  );
};

export default MFAOptions;